import {
    KEYBOARD_SHORTCUTS_UPDATED_EVENT,
    getStoredKeyboardShortcuts,
} from "@app/lib/keyboardShortcuts.js";
import { environment } from "@app/store/envStore.svelte.js";

const KEY_DISPLAY = {
    Backquote: "`",
    Minus: "-",
    Equal: "=",
    BracketLeft: "[",
    BracketRight: "]",
    Backslash: "\\",
    Semicolon: ";",
    Quote: "'",
    Comma: ",",
    Period: ".",
    Slash: "/",
    Space: "Space",
    Tab: "Tab",
    Enter: "Enter",
    Escape: "Esc",
    ArrowUp: "↑",
    ArrowDown: "↓",
    ArrowLeft: "←",
    ArrowRight: "→",
    NumpadMultiply: "Num *",
    NumpadDivide: "Num /",
    NumpadAdd: "Num +",
    NumpadSubtract: "Num -",
};

const hints = $state({
    byName: /** @type {Record<string, string>} */ ({}),
});

function formatKeyToken(token, isMac) {
    if (token === "Meta(CMD)" || token === "Meta") {
        return isMac ? "⌘" : "Ctrl";
    }
    if (token === "Ctrl" || token === "Control") {
        return isMac ? "⌘" : "Ctrl";
    }
    if (token === "Shift") {
        return isMac ? "⇧" : "Shift";
    }
    if (token === "Alt" || token === "Option") {
        return isMac ? "⌥" : "Alt";
    }
    if (KEY_DISPLAY[token]) {
        return KEY_DISPLAY[token];
    }
    if (token.startsWith("Key") && token.length === 4) {
        return token.slice(3);
    }
    if (token.startsWith("Digit") && token.length === 6) {
        return token.slice(5);
    }
    if (token.startsWith("Numpad") && token.length === 7) {
        return "Num " + token.slice(6);
    }
    return token;
}

/**
 * @param {string} keyCmd
 * @param {boolean} [isMac]
 * @returns {string}
 */
export function formatKeyCmd(keyCmd, isMac = environment.mac) {
    if (!keyCmd) {
        return "";
    }

    const parts = keyCmd.split("+").map((token) => formatKeyToken(token, isMac));
    return isMac ? parts.join("") : parts.join("+");
}

function rebuildHints(shortcutGroups) {
    const next = {};
    const isMac = environment.mac;

    for (const group of shortcutGroups || []) {
        for (const shortcut of group.shortcuts || []) {
            if (shortcut.name && shortcut.keyCmd) {
                next[shortcut.name] = formatKeyCmd(shortcut.keyCmd, isMac);
            }
        }
    }

    hints.byName = next;
}

function loadHints(shortcutGroups) {
    try {
        rebuildHints(
            shortcutGroups || getStoredKeyboardShortcuts(environment.mac),
        );
    } catch (err) {
        console.warn("Failed to load menu shortcut hints:", err);
        hints.byName = {};
    }
}

loadHints();

if (typeof window !== "undefined") {
    window.addEventListener(KEYBOARD_SHORTCUTS_UPDATED_EVENT, (event) => {
        loadHints(event.detail?.shortcuts);
    });
}

/**
 * @param {string} name Shortcut config name, e.g. "Save Project"
 * @returns {string}
 */
export function getShortcutHint(name) {
    if (!name) {
        return "";
    }
    return hints.byName[name] || "";
}
